
import { NodeCategory } from './types';

// Canvas-level status indicator colors (minimap, edges) — shared by editor & simulator.
export const CANVAS_STATUS_COLORS = {
  error: '#ef4444',      // Red 500
  active: '#14b8a6',     // Teal 500
  completed: '#10b981',  // Emerald 500
  default: '#94a3b8',    // Slate 400 — also used for neutral edge strokes
} as const;

// Background dot grid colors, per theme.
export const CANVAS_BACKGROUND_COLORS = {
  light: '#cbd5e1', // Slate 300
  dark: '#334155',  // Slate 700
} as const;

export const NODE_CATEGORIES = [
  NodeCategory.Start,
  NodeCategory.Task,
  NodeCategory.Gateway,
  NodeCategory.Activity,
  NodeCategory.Intermediate,
  NodeCategory.Boundary,
  NodeCategory.End,
];